import { register } from 'swiper/element/swiper-element';
import { Navigation, Pagination, Mousewheel, SwiperOptions, FreeMode } from 'swiper';
import { Swiper } from 'swiper/types';


let swiperRegistered = false;

export function initInsights(wrapper: HTMLDivElement) {

	if (!swiperRegistered) {
		register();
		swiperRegistered = true;
	}

	let container = wrapper.querySelector<Swiper>('swiper-container');
	if (!container) {
		console.error('No swiper-container in insights panel!');
		return;
	}

	let paginationWrapper = wrapper.querySelector('[data-swiper-pagination]');

	let params: SwiperOptions = {
		modules: [ Navigation, Pagination, Mousewheel, FreeMode ],
		mousewheel: {
			forceToAxis: true,
		},
		slidesPerView: 1,
		pagination: {
			el: paginationWrapper,
			bulletClass: 'insights__bullet',
			bulletActiveClass: 'insights__bullet--active',
			clickable: true,
		},
		navigation: {
			prevEl: wrapper.querySelector('[data-swiper-prev]'),
			nextEl: wrapper.querySelector('[data-swiper-next]'),
			disabledClass: 'arrow-button--disabled',
		},
		freeMode: {
			sticky: true,
			momentumRatio: 0.5,
		},
		breakpoints: {
			1010: {
				slidesPerView: 3,
			},
		}
	};

	Object.assign(container, params);

	container.initialize();

}
